import { render, staticRenderFns } from "./ScoreWidget.vue?vue&type=template&id=19df3438"
import script from "./ScoreWidget.vue?vue&type=script&lang=js"
export * from "./ScoreWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports